/* eslint-disable no-undef */
import React from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import {
    UserHeading,
    User,
    Username,
    UserName1,
    TextBold,
    Designation,
    BottomNavigationButtonContainer,
} from './index.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import {
    DS_USER_ROLE,
    CSR_USER_ROLE,
    DCA_USER_ROLE,
    PL_USER_ROLE,
    LATAM_USER_ROLE,
    RVP_USER_ROLE,
    RCM_USER_ROLE,
    SP_USER_ROLE,
    SOC_USER_ROLE,
    MENU,
} from 'src/constants/appConstants';
import {
    checkImpersonationActive,
    clearDataOnNewImpersonate,
    logErrorToConsole,
    getWcmsHostName,
    saveAccountFilterStateForImpersonation,
    savePhysicianFilterStateForImpersonation,
    saveOrderFilterStateForImpersonation,
} from 'src/utils/util';
import {
    getImpersonationUserData,
    setImpersonateCheckAction,
} from 'src/pages/impersonation/redux/actions/index.js';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import UserEmphasis from 'src/assets/images/UserEmphasis.svg';
import { useTranslation } from 'react-i18next';
import {
    adminImpersonateProxy,
    setAdminSearchOpen,
    setAdminFilterParamValues,
    setAdminFilters,
    resetRoles,
    resetTerritory,
    setAdminFilterParams,
    setShowLocalExpandedView,
    setAppliedFilter,
    setClearFilter,
    getFilterData,
    getAdminUserList,
    setFilterAppliedView,
    setSelectedViews,
    setSelectedSalesOrg,
} from 'src/pages/admin/redux/action';
import { useHistory } from 'react-router-dom';
import { ProxyPopupContainer } from '../nameDetails/index.styled';
import {
    getPageVisibilityRule,
    resetCalendarFilterDataAfterImpersonation,
    setFilters,
} from 'src/pages/home/redux/actions';
import { getConfigurations } from 'src/common/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const ImpersonateProxy = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const store = useStore();
    const history = useHistory();

    const initiateProxyStatus = useSelector(
        (state) => state.AdminProxyReducer.initiateProxyStatus
    );
    const { appliedView } = useSelector((state) => state.AdminReducer);

    const resetAppliedView = () => {
        // setSearchParamValues('');
        // setAccountFilterParamValues('');
        dispatch(setAdminFilterParamValues(''));
        dispatch(
            setSelectedViews({
                salesOrgView: [
                    {
                        name: 'All',
                        value: 'All',
                        isChecked: true,
                        isDefault: true,
                    },
                ],
                districtView: { id: 'All District', name: 'All' },
                territoryView: { id: 'All Territory', name: 'All' },
                roleView: { id: 'All', name: 'All' },
            })
        );
        // setAccountFilterParamValues = '';
        if (appliedView) {
            appliedView.appliedDistrict = {};
            appliedView.appliedTerritory = {};
            appliedView.appliedRole = {};
        }
        dispatch(setAdminFilters({}));
        dispatch(resetRoles());
        dispatch(resetTerritory());
        dispatch(setAdminFilterParams({}));
        dispatch(setClearFilter(true));
        dispatch(getFilterData(false));

        dispatch(getAdminUserList());
        dispatch(setFilterAppliedView());
        // dispatch(setSelectedSalesOrg());

        dispatch(
            setShowLocalExpandedView({
                districtView: true,
                territoryView: false,
                roleView: false,
            })
        );

        dispatch(
            setAppliedFilter({
                appliedsalesOrgView: [],
                appliedDistrict: {},
                appliedTerritory: {},
                appliedRole: {},
            })
        );
    };
    const { filterDataOpen } = useSelector((state) => ({
        filterDataOpen: state.AdminReducer.filterDataOpen,
        salesOrg: state.AdminReducer.salesOrg,
    }));
    useEffectWithErrorLogging(() => {
        if (initiateProxyStatus === '200') {
            dispatch(setSelectedSalesOrg([]));
            if (filterDataOpen) {
                props.setClearFilterClicked(true);
                resetAppliedView();
            }
            dispatch(
                setFilters({
                    filterParam: '',
                })
            );
            dispatch(resetCalendarFilterDataAfterImpersonation());
            // const sideNavLink =
            //     'view/content/InventoryDashBoardListPage?getDashBoardDistricts=true&currentTab=surgeryNeeds&refine=false&search=false';
            saveAccountFilterStateForImpersonation(store.getState());
            savePhysicianFilterStateForImpersonation(store.getState());
            saveOrderFilterStateForImpersonation(store.getState());
            clearDataOnNewImpersonate(dispatch);
            localStorage.setItem(
                'userBaseSiteId',
                localStorage.getItem('baseSiteId')
            );
            localStorage.setItem(
                'baseSiteId',
                props.impersonateProxyData.baseSiteId
            );
            sessionStorage.setItem(
                'impersonatedUserId',
                props.impersonateProxyData.networkIdName
            );
            if (sessionStorage.getItem('ProxyUserRole') === CSR_USER_ROLE) {
                history.push(
                    `/orders?impersonatedFlag=true&impersonatedUser=${props.impersonateProxyData.networkIdName}`
                );
            } else if (
                sessionStorage.getItem('ProxyUserRole') === DCA_USER_ROLE ||
                sessionStorage.getItem('ProxyUserRole') === PL_USER_ROLE ||
                sessionStorage.getItem('ProxyUserRole') === LATAM_USER_ROLE ||
                sessionStorage.getItem('ProxyUserRole') === RCM_USER_ROLE ||
                sessionStorage.getItem('ProxyUserRole') === RVP_USER_ROLE ||
                sessionStorage.getItem('ProxyUserRole') === SP_USER_ROLE ||
                sessionStorage.getItem('ProxyUserRole') === SOC_USER_ROLE ||
                sessionStorage.getItem('ProxyUserRole') === DS_USER_ROLE
            ) {
                window.setTimeout(function () {
                    try {
                        window.location.replace(
                            `${getWcmsHostName()}/?impersonatedFlag=true&impersonatedUser=${props.impersonateProxyData.networkIdName}`
                        );
                    }
                    catch (error) {
                        logErrorToConsole(error);
                    }
                }, 0);
            } else {
                history.push(
                    `/?impersonatedFlag=true&impersonatedUser=${props.impersonateProxyData.networkIdName}`
                );
            }

            dispatch(
                setImpersonateCheckAction({
                    isImpersonationActive: checkImpersonationActive(),
                })
            );
            dispatch(getImpersonationUserData());
            dispatch(getConfigurations({resourceType: 'PROCESS'}, MENU));
            dispatch(getPageVisibilityRule({ fields: 'BASIC' }));
            dispatch(setAdminSearchOpen(false));
            if (props.isNameDetails) {
                props.setshowNameDetails(false);
            }
            //props.handleClose();
        }
    }, [initiateProxyStatus]);

    const openHome = () => {
        dispatch(adminImpersonateProxy(props.impersonateProxyData));
        // let salesOrgsData = [];
        // (salesOrg ? salesOrg : selectedViews.salesOrgView).map((item) => {
        //     if (item.isChecked || item.isDefault) {
        //         salesOrgsData.push(item.value);
        //     }
        // });
        // const param = {
        //     sortParams: 'name',
        //     salesOrgs: salesOrgsData.join(','),
        //     filteredDistrict: appliedView?.appliedDistrict.id,
        //     filteredTerritory: appliedView?.appliedTerritory.id,
        //     filteredRole: appliedView?.appliedRole.id,
        // };
        // sessionStorage.setItem('param',JSON.stringify(param));
        // isImpersonationActive && dispatch(
        //     setAppliedFilter({
        //         appliedsalesOrgView: [],
        //         appliedDistrict: {},
        //         appliedTerritory: {},
        //         appliedRole: {},
        //     })
        // );
        // window.sessionStorage.setItem(
        //     'appliedData',
        //     JSON.stringify(appliedView)
        // );
        // if (props.isNameDetails) {
        //     props.setshowImpersonateProxy(false);
        // }
    };

    const closeHome = () => {
        props.handleClose();
    };
    useEffectWithErrorLogging(() => {
        if (typeof document !== 'undefined') {
            document.body.classList.add('admin-impersonate-proxy-popup-open');
        }
 
        return () => {
            if (typeof document !== 'undefined') {
                document.body.classList.remove('admin-impersonate-proxy-popup-open');
            }
        };
    }, []);
    return (
        <>
            <Popup
                title={'Impersonate'}
                onClose={props.handleClose}
                borderRadius={'6px'}
                id={'admin-impersonateProxy-index-popup'}
                impersonationBackground={'rgba(47, 45, 70, 0.83)'}
            >
                <ProxyPopupContainer
                    divHeight={
                        props.impersonateProxyData.userRoles[0] !==
                        'Un-assigned'
                            ? 'fit-content'
                            : '155px'
                    }
                    mbDivHeight={
                        props.impersonateProxyData.userRoles[0] !==
                        'Un-assigned'
                            ? 'fit-content'
                            : '190px'
                    }
                    divWidth={'300px'}
                >
                    <UserHeading>
                        {props.impersonateProxyData.userRoles[0] !==
                        'Un-assigned'
                            ? t('admin.impersonate.heading')
                            : 'Cannot Impersonate User. The user\'s not assigned with any user group.'}
                    </UserHeading>
                    {props.impersonateProxyData.userRoles[0] !==
                    'Un-assigned' ? (
                        <UserName1
                            style={{
                                fontSize: '14px',
                                fontFamily: 'AvenirNextWorld Demi',
                            }}
                        >
                            {t('admin.impersonate.user')}
                        </UserName1>
                    ) : null}
                    {props.impersonateProxyData.userRoles[0] !==
                    'Un-assigned' ? (
                        <div
                            style={{
                                display: 'inline-flex',
                                padding: '0px 0 0 0',
                            }}
                        >
                            <img
                               // marginTop={'10px'}
                                src={UserEmphasis}
                                alt={'.png'}
                                width={'31.7px'}
                                height={'31.7px'}
                            />
                            <User style={{ marginTop: '-10px' }}>
                                <Username className="admin-person-name-dt-mask">
                                    {props.impersonateProxyData.firstName}{' '}
                                    {props.impersonateProxyData.lastName}
                                </Username>
                                <Designation>
                                    {props.impersonateProxyData.userRoles}
                                </Designation>
                            </User>
                        </div>
                    ) : null}
                    <BottomNavigationButtonContainer
                        mbPadding={'0px 0px 0px 0px'}
                    >
                        <Button
                            id={'page-admin-impersonate-cancel'}
                            clearNotes
                            show={true}
                            //cancel={true}
                            width={'144px'}
                            height={'38px'}
                            mobileWidth={'144px'}
                            margin={'16px 4px 0px 4px'}
                            mobileMargin={'15px 5px 10px 15px'}
                            clicked={closeHome}
                            variant={ButtonStyles.cancel}
                        >
                            <TextBold color={'#140F4B'}>
                                {t('admin.impersonate.cancel')}
                            </TextBold>
                        </Button>
                        <Button
                            id={'page-admin-impersonate-continue'}
                            show
                            
                            // primary={
                            //     props.impersonateProxyData.userRoles[0] !==
                            //     'Un-assigned'
                            // }
                            // disabledSaveBtn={
                            //     props.impersonateProxyData.userRoles[0] ===
                            //     'Un-assigned'
                            //         ? true
                            //         : false
                            // }
                            variant={props.impersonateProxyData.userRoles[0] !== 'Un-assigned' ? ButtonStyles.primary : ButtonStyles.disabled}
                            // disble should be applied
                            disabled={
                                props.impersonateProxyData.userRoles[0] ===
                                'Un-assigned'
                                    ? true
                                    : false
                            }
                            width={'144px'}
                            height={'38px'}
                            mobileWidth={'144px'}
                            mobileMargin={'15px 15px 10px 10px'}
                            margin={'16px 4px 0px 4px'}
                            clicked={openHome}
                        >
                            <TextBold color={'#FFFF'}>
                                {t('admin.impersonate.continue')}
                            </TextBold>
                        </Button>
                    </BottomNavigationButtonContainer>
                </ProxyPopupContainer>
            </Popup>
        </>
    );
};
export default ImpersonateProxy;
